import { render } from "./ExternalLinkUnsuccessful.vue?vue&type=template&id=bfcda610&scoped=true"
import script from "./ExternalLinkUnsuccessful.vue?vue&type=script&lang=js"
export * from "./ExternalLinkUnsuccessful.vue?vue&type=script&lang=js"

import "./ExternalLinkUnsuccessful.vue?vue&type=style&index=0&id=bfcda610&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcda610"]])

export default __exports__